import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/ieo/Start.png';
import _imports_1 from '../../assets/ieo/Initial.png';
import _imports_2 from '../../assets/ieo/Finish.png';
import _imports_3 from '../../assets/ieo/Launch.png';

const _withScopeId = n => (_pushScopeId("data-v-39c36ef2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ieo-tab"
};
const _hoisted_2 = {
  class: "ieo-des"
};
const _hoisted_3 = {
  class: "ieo-card ieo-name"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  style: {
    "width": "50%"
  }
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  class: "ieo-tag"
};
const _hoisted_8 = {
  class: "ieo-tag",
  href: "https://www.erswhitepaper.online",
  style: {
    "margin-left": "10px",
    "background-color": "#F08504"
  },
  target: "_blank"
};
const _hoisted_9 = {
  class: "ieo-card"
};
const _hoisted_10 = {
  class: "ieo-progress"
};
const _hoisted_11 = {
  class: "progress-item"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_13 = {
  class: "progress-name"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "progress-date"
}, "12/22/2024", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {
    "width": "80px",
    "height": "2px",
    "background-color": "#04AC92",
    "border-radius": "4px"
  }
}, null, -1));

const _hoisted_16 = {
  class: "progress-item"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_18 = {
  class: "progress-name"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "progress-date"
}, "3/23/2026", -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {
    "width": "80px",
    "height": "2px",
    "background-color": "#D04C64",
    "border-radius": "4px"
  }
}, null, -1));

const _hoisted_21 = {
  class: "progress-item"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));

const _hoisted_23 = {
  class: "progress-name"
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "progress-date"
}, "11/30/2026", -1));

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {
    "width": "80px",
    "height": "2px",
    "background-color": "#D04C64",
    "border-radius": "4px"
  }
}, null, -1));

const _hoisted_26 = {
  class: "progress-item"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));

const _hoisted_28 = {
  class: "progress-name"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "progress-date"
}, "12/01/2026", -1));

const _hoisted_30 = {
  class: "ieo-card"
};
const _hoisted_31 = {
  class: "label",
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$ " + /*#__PURE__*/_toDisplayString(4), -1));

const _hoisted_33 = {
  class: "label",
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_34 = {
  class: "label",
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_35 = {
  class: "ieo-card"
};
const _hoisted_36 = {
  class: "label"
};

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "51% (306,000,000)", -1));

const _hoisted_38 = {
  class: "label"
};

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "10% (60,000,000)", -1));

const _hoisted_40 = {
  class: "label"
};

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "8% (48,000,000)", -1));

const _hoisted_42 = {
  class: "label"
};

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "25% (150,000,000)", -1));

const _hoisted_44 = {
  class: "label"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "value"
}, "6% (36,000,000)", -1));

const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "two-chart",
  style: {
    "width": "calc(100vw - 40px)",
    "height": "calc(100vw + 50px)",
    "margin-top": "-100px"
  }
}, null, -1));

const _hoisted_47 = {
  class: "ieo-trade"
};
const _hoisted_48 = {
  style: {
    "height": "53px"
  }
};
const _hoisted_49 = {
  class: "ieo-options"
};
const _hoisted_50 = {
  class: "fb"
};
const _hoisted_51 = {
  key: 0,
  class: "select-btn"
};

const _hoisted_52 = /*#__PURE__*/_createTextVNode(" USDT ");

const _hoisted_53 = /*#__PURE__*/_createTextVNode(" USDC ");

const _hoisted_54 = /*#__PURE__*/_createTextVNode(" BTC ");

const _hoisted_55 = /*#__PURE__*/_createTextVNode(" ETH ");

const _hoisted_56 = {
  key: 1,
  class: "ieo-price-best mt"
};

const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#919497",
    "font-weight": "700",
    "padding": "0 10px"
  }
}, "ERS", -1));

const _hoisted_58 = {
  class: "use-asset mt",
  style: {
    "color": "var(--text-color)"
  }
};
const _hoisted_59 = {
  key: 0
};
const _hoisted_60 = {
  key: 1
};
const _hoisted_61 = {
  key: 0,
  style: {
    "color": "#919497",
    "font-weight": "700",
    "padding": "0 10px"
  }
};
const _hoisted_62 = {
  key: 1,
  style: {
    "color": "#919497",
    "font-weight": "700",
    "padding": "0 10px"
  }
};
const _hoisted_63 = {
  style: {
    "min-height": "calc(100vh - 190.7px)",
    "background-color": "var(--atbg-color)"
  }
};
const _hoisted_64 = {
  style: {
    "min-height": "calc(100vh - 190.7px)",
    "background-color": "var(--atbg-color)"
  }
};
import { ref, onActivated, watch, reactive, onBeforeMount } from 'vue';
import store from '@/store'; // import moment from 'moment'

import TradeOptionHeader from '@/components/TradeOptionHeader.vue';
import IEOOrderList from '@/components/IEOOrderList.vue';
import CustomTab from '@/components/CustomTab.vue';
import EmptyLogin from '@/components/EmptyLogin.vue'; // import IEOLockList from '@/components/IEOLockList.vue'

import IEOSellList from '@/components/IEOSellList.vue';
import { getUserAsset, ieoTrade, getUserInfo, marketIeo, userInfo } from '@/apis';
import BigNumber from 'bignumber.js';
import { fmtNumber } from '@/util';
import { RightOutlined } from '@ant-design/icons-vue';
import { useRoute } from 'vue-router';
import * as echarts from 'echarts/core';
import { ToolboxComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { Dialog, Toast } from 'vant';
import 'vant/es/toast/style';
import { useI18n } from "vue-i18n";
export default {
  __name: 'IEOTab',
  emits: ["tabbarIndexChange"],

  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    echarts.use([ToolboxComponent, LegendComponent, PieChart, CanvasRenderer, LabelLayout, TooltipComponent]);
    const ieoOrder = ref();
    const lockOrder = ref();
    const ieoSellOrder = ref();
    const route = useRoute();
    const loading = ref(false);
    const numInput = ref(false);
    const totalInput = ref(false);
    const form = reactive({
      number: null,
      total: null
    });
    const tabActive = ref(0);
    const klineKey = ref('');
    const sellDisabled = ref(true);
    const ieoType = ref(0);
    const assetList = ref({});
    const ieoCurrency = ref('USDT'); // const typeAsset = ref(0)
    // const usePledge = ref(0)

    const useService = ref(0); // const total = ref(800000000)

    const buyTotal = ref(0);
    const ieoTabActive = ref('0');
    onBeforeMount(() => {
      getAsset();
      getMarketIeo();
    });

    const getMarketIeo = () => {
      marketIeo({}).then(res => {
        if (res.code === 200 && res.data) {
          klineKey.value = res.data.marketSymbol;
          buyInfo.value.minCount = res.data.ieoTradeMin;
          buyInfo.value.maxNum = res.data.ieoDayNum;
          buyInfo.value.icon = process.env.VUE_APP_IMG + res.data.icon;
          buyInfo.value.name = res.data.marketName;
          buyTotal.value = res.data.ieoBuyAmount;
          sellDisabled.value = res.data.ieoAllSell ? false : true;
          getUserInfoMsg();
          ieoChartInit();
        }
      });
    };

    const getUserInfoMsg = () => {
      userInfo({}).then(res => {
        if (res.code === 200 && res.data) {
          if (sellDisabled.value == true) {
            sellDisabled.value = res.data.ieoSellState ? false : true;
          }
        }
      });
    };

    const disabled = ref(true);
    const planNum = ref({
      ieointro1: 306000000,
      ieointro2: 60000000,
      ieointro3: 48000000,
      ieointro4: 150000000,
      ieointro5: 36000000
    });
    const buyInfo = ref({
      issue: 0,
      minCount: 0,
      maxCount: 0,
      maxNum: 0,
      step: 0,
      icon: '',
      name: ''
    });
    watch(() => form.total, () => {
      if (totalInput.value) {
        const totalNum = Number(form.total);

        if (totalNum < 0) {
          form.total = 0;
        }

        let decimal = 8;

        if (store.state.marketInfo[klineKey.value] && store.state.marketInfo[klineKey.value].decimal > 8) {
          decimal = store.state.marketInfo[klineKey.value].decimal;
        }

        if (ieoCurrency.value !== 'USDT') {
          const cntKey = `${ieoCurrency.value}USDT`;

          if (store.state.market[klineKey.value]) {
            const last = store.state.market[cntKey] ? store.state.market[cntKey].last : 0;
            form.number = BigNumber(form.total).multipliedBy(last).dividedBy(store.state.market[klineKey.value].last).toFixed(8);
          } else {
            form.number = 0;
          }
        } else {
          const price = store.state.market[klineKey.value] ? Number(store.state.market[klineKey.value].last) : 0;

          if (form.total && price > 0) {
            form.number = BigNumber(form.total).dividedBy(price).toFixed(decimal);
          }
        }

        if (form.total === null && form.number) {
          form.number = null;
        }
      }
    });
    watch(() => form.number, () => {
      if (numInput.value) {
        const num = Number(form.number);

        if (num < 0) {
          form.number = 0;
        }

        let decimal = 8;

        if (store.state.marketInfo[klineKey.value] && store.state.marketInfo[klineKey.value].decimal > 8) {
          decimal = store.state.marketInfo[klineKey.value].decimal;
        }

        if (ieoCurrency.value !== 'USDT') {
          const cntKey = `${form.ieo}USDT`;

          if (store.state.market[cntKey]) {
            const last = store.state.market[klineKey.value] ? store.state.market[klineKey.value].last : 0;
            form.total = BigNumber(form.number).multipliedBy(last).dividedBy(store.state.market[cntKey].last).toFixed(8);
          } else {
            form.total = 0;
          }
        } else {
          const price = store.state.market[klineKey.value] ? Number(store.state.market[klineKey.value].last) : 0;

          if (form.number) {
            form.total = Number(BigNumber(price).multipliedBy(form.number).toFixed(decimal));
          }
        }

        if (ieoType.value === 1 && Number(cntScale.value) > 0) {
          form.total = BigNumber(form.total).multipliedBy(cntScale.value).toFixed(decimal);
        } else if (ieoType.value === 2 && sellScale.value > 0) {
          form.total = BigNumber(form.total).multipliedBy(sellScale.value).toFixed(decimal);
        }
      }

      if (form.number === null && form.total) {
        form.total = null;
      }
    });

    const ieoChange = type => {
      form.number = null;
      form.total = null;
      ieoCurrency.value = type;
    };

    const onRefresh = () => {
      loading.value = true;

      if (tabActive.value === 1) {
        orderLoad();
        getAsset();
      }

      loading.value = false;
    };

    const ieoChartInit = () => {
      const twoChart = echarts.init(document.getElementById('two-chart'));
      const planData = [{
        value: planNum.value.ieointro1,
        name: t('ieointro10')
      }, {
        value: planNum.value.ieointro2,
        name: t('ieointro11')
      }, {
        value: planNum.value.ieointro3,
        name: t('ieointro12')
      }, {
        value: planNum.value.ieointro4,
        name: t('ieointro13')
      }, {
        value: planNum.value.ieointro5,
        name: t('ieointro14')
      }]; // twoChart.setOption({
      //     tooltip: {
      //       trigger: 'item',
      //       formatter: '{b}<br/>{c} ({d}%)'
      //     },
      //     legend: {
      //       data: [
      //         t('sellTotal'),
      //         t('currentBuy'),
      //       ],
      //       textStyle: {color: '1'},
      //       orient: 'vertical',
      //       left: 'center',
      //       top:'bottom',
      //     },
      //     series: [
      //       {
      //         name: 'Access From',
      //         type: 'pie',
      //         radius: [0, '30%'],
      //         minAngle:10,
      //         center: ['50%', '60%'],
      //         label: {
      //           show: false
      //         },
      //         labelLine: {
      //           show: false
      //         },
      //         data: [
      //           { value: total.value, name: t('sellTotal') },
      //           { value: buyTotal.value, name: t('currentBuy') },
      //         ],
      //       },
      //       {
      //         name: 'Access From',
      //         type: 'pie',
      //         radius: ['45%', '60%'],
      //         center: ['50%', '60%'],
      //         label: {
      //           show: false
      //         },
      //         labelLine: {
      //           show: false
      //         },
      //         data: planData
      //       }
      //     ]
      //   })

      twoChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)'
        },
        legend: {
          top: 'bottom'
        },
        series: [{
          name: 'Nightingale Chart',
          type: 'pie',
          radius: [30, 70],
          center: ['50%', '50%'],
          roseType: 'area',
          itemStyle: {
            borderRadius: 6
          },
          data: planData
        }]
      });
    };

    const commit = () => {
      let beforeClose = null;

      if (ieoType.value === 0) {
        if (Number(form.number) <= 0) {
          Toast({
            message: t('tradeNumTip'),
            position: 'bottom'
          });
          return;
        }

        beforeClose = action => {
          return new Promise(resolve => {
            if (action === 'confirm') {
              const data = {
                marketId: store.state.marketInfo[klineKey.value]?.id,
                tradeMarket: ieoCurrency.value,
                tradeNum: Number(form.total),
                ieoNum: Number(form.number),
                side: 0
              };
              ieoTrade(data).then(res => {
                if (res.code !== 200) {
                  resolve(false);
                  Toast({
                    message: res.msg !== '' ? res.msg : t('tradeError'),
                    position: 'bottom'
                  });
                  return;
                }

                Toast({
                  message: res.msg !== '' ? res.msg : t('tradeSuccess'),
                  position: 'bottom'
                });
                resolve(true);
                getAsset();
                ieoOrder.value.init(1);
                form.number = null;
                form.total = null;
              });
            } else {
              resolve(true);
            }
          });
        };
      } else {
        if (Number(form.number) <= 0) {
          Toast({
            message: t('tradeNumTip'),
            position: 'bottom'
          });
          return;
        }

        beforeClose = action => {
          return new Promise(resolve => {
            if (action === 'confirm') {
              const data = {
                marketId: store.state.marketInfo[klineKey.value]?.id,
                tradeMarket: 'USDT',
                tradeNum: Number(form.total),
                ieoNum: Number(form.number),
                side: 1
              };
              ieoTrade(data).then(res => {
                if (res.code !== 200) {
                  resolve(false);
                  Toast({
                    message: res.msg !== '' ? res.msg : t('tradeError'),
                    position: 'bottom'
                  });
                  return;
                }

                Toast({
                  message: res.msg !== '' ? res.msg : t('tradeSuccess'),
                  position: 'bottom'
                });
                resolve(true);
                getAsset();
                ieoOrder.value.init(1);
                form.number = null;
                form.total = null;
              });
            } else {
              resolve(true);
            }
          });
        };
      }

      Dialog.confirm({
        title: t('tip'),
        message: t('tradeConfirm'),
        cancelButtonText: t('cancelText'),
        confirmButtonText: t('confirmText'),
        beforeClose
      }).catch(() => {});
    };

    const getAsset = () => {
      getUserAsset({
        platform: 0
      }).then(res => {
        if (res.code === 200 && res.data) {
          res.data?.forEach(item => {
            switch (item.marketName) {
              case 'USDT':
                assetList.value['USDT'] = item.active ? Number(item.active).toFixed(4) : 0;
                break;

              case 'BTC':
                assetList.value['BTC'] = item.active ? Number(item.active).toFixed(4) : 0;
                break;

              case 'ETH':
                assetList.value['ETH'] = item.active ? Number(item.active).toFixed(4) : 0;
                break;

              case 'USDC':
                assetList.value['USDC'] = item.active ? Number(item.active).toFixed(4) : 0;
                break;

              case 'ERS':
                useService.value = item.active ? Number(item.active).toFixed(4) : 0;
                break;
            }
          });
        }
      });
    };

    let orderIndex = 0;

    const orderLoad = () => {
      switch (orderIndex) {
        case 0:
          ieoOrder.value?.init(1);
          break;

        case 1:
          lockOrder.value?.init(1);
          break;

        case 2:
          ieoSellOrder.value?.init(1);
          break;
      }
    };

    const orderChange = index => {
      orderIndex = index;
      orderLoad();
    };

    const cntScale = ref('0');
    const pledgeEnable = ref(false); // const serviceEnable = ref(false)

    const sellScale = ref(0);
    onActivated(async () => {
      if (Number(route.query.active) === 1) {
        tabActive.value = 1;
      }

      emit('tabbarIndexChange', 2);

      if (route.query.type) {
        switch (route.query.type) {
          case '1':
            ieoType.value = 0;
            break;

          case '2':
            ieoType.value = 2;
            break;
        }
      }

      if (store.state.token !== '') {
        getUserInfo().then(res => {
          if (res.code === 200 && res.data) {
            if (res.data.user_ieo_coin_sell == 1) {
              disabled.value = false;
            }
          }
        });
        orderLoad();
      }
    });
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");

      const _component_van_col = _resolveComponent("van-col");

      const _component_van_row = _resolveComponent("van-row");

      const _component_a_tab_pane = _resolveComponent("a-tab-pane");

      const _component_a_tabs = _resolveComponent("a-tabs");

      const _component_van_tab = _resolveComponent("van-tab");

      const _component_van_button = _resolveComponent("van-button");

      const _component_a_input_number = _resolveComponent("a-input-number");

      const _component_van_tabs = _resolveComponent("van-tabs");

      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        class: "ieo-nav",
        "safe-area-inset-top": true,
        fixed: true,
        placeholder: true,
        "z-index": "200",
        border: false
      }, {
        left: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(tabActive.value === 0 ? 'ieo-nav-active' : 'ieo-nav-item'),
          style: {
            "clipPath": "polygon(0 0, 100% 0, 95% 100%, 0 100%)"
          },
          onClick: _cache[0] || (_cache[0] = $event => tabActive.value = 0)
        }, _toDisplayString(_unref(t)('introduce')), 3)]),
        right: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(tabActive.value === 1 ? 'ieo-nav-active' : 'ieo-nav-item'),
          style: {
            "clipPath": "polygon(5% 0, 100% 0, 100% 100%, 0 100%)"
          },
          onClick: _cache[1] || (_cache[1] = $event => tabActive.value = 1)
        }, _toDisplayString(_unref(t)('tradename')), 3)]),
        _: 1
      }), _createVNode(_component_van_pull_refresh, {
        modelValue: loading.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => loading.value = $event),
        onRefresh: onRefresh,
        "pulling-text": _unref(t)('pulling'),
        "loosing-text": _unref(t)('loosing'),
        "loading-text": _unref(t)('loading')
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabs, {
          active: tabActive.value,
          "onUpdate:active": _cache[15] || (_cache[15] = $event => tabActive.value = $event),
          sticky: "",
          "lazy-render": false,
          style: {
            "--van-tabs-bottom-bar-height": "0",
            "--van-tab-font-size": "15px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tab, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
              src: buyInfo.value.icon,
              style: {
                "width": "80px",
                "height": "100%"
              }
            }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, " Energy Ecological Reserve Smart Chain(" + _toDisplayString(buyInfo.value.name) + ") ", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('ieoBuying')), 1), _createElementVNode("a", _hoisted_8, _toDisplayString(_unref(t)('whitePaper')), 1)])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('ieoStart')), 1), _hoisted_14]), _hoisted_15, _createVNode(_unref(RightOutlined), {
              style: {
                "font-size": "17px",
                "color": "#04AC92",
                "margin-left": "-12px",
                "font-weight": "600"
              }
            }), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('ieoBuyStart')), 1), _hoisted_19]), _hoisted_20, _createVNode(_unref(RightOutlined), {
              style: {
                "font-size": "17px",
                "color": "#D04C64",
                "margin-left": "-12px",
                "font-weight": "600"
              }
            }), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('ieoBuyEnd')), 1), _hoisted_24]), _hoisted_25, _createVNode(_unref(RightOutlined), {
              style: {
                "font-size": "17px",
                "color": "#D04C64",
                "margin-left": "-12px",
                "font-weight": "600"
              }
            }), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('ieoIsTrade')), 1), _hoisted_29])])]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_van_row, null, {
              default: _withCtx(() => [_createVNode(_component_van_col, {
                span: 24,
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", null, _toDisplayString(_unref(t)('issuePrice')) + " :", 1), _hoisted_32])]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: 24,
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", null, _toDisplayString(_unref(t)('minBuyPrice')) + " :", 1), _createElementVNode("span", null, _toDisplayString(_unref(fmtNumber)(buyInfo.value.minCount)), 1)])]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: 24,
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("span", null, _toDisplayString(_unref(t)('buyNum')) + " :", 1), _createElementVNode("span", null, _toDisplayString(_unref(fmtNumber)(buyInfo.value.maxNum)), 1)])]),
                _: 1
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_35, [_createVNode(_component_a_tabs, {
              activeKey: ieoTabActive.value,
              "onUpdate:activeKey": _cache[2] || (_cache[2] = $event => ieoTabActive.value = $event),
              class: "custom-tab"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
                key: "0",
                tab: _unref(t)('ieoIntro')
              }, null, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
                key: "1",
                tab: _unref(t)('ieoPlan')
              }, null, 8, ["tab"])]),
              _: 1
            }, 8, ["activeKey"]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(_unref(t)('ieoDes10')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('ieoDes11')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('ieoDes12')), 1)], 512), [[_vShow, ieoTabActive.value == 0]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_van_row, null, {
              default: _withCtx(() => [_createVNode(_component_van_col, {
                span: "12",
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)('ieointro10')), 1), _hoisted_37]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12",
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('ieointro11')), 1), _hoisted_39]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12",
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)('ieointro12')), 1), _hoisted_41]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12",
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('ieointro13')), 1), _hoisted_43]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12",
                class: "ieo-data-item"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('ieointro14')), 1), _hoisted_45]),
                _: 1
              })]),
              _: 1
            }), _hoisted_46], 512), [[_vShow, ieoTabActive.value == 1]])])])]),
            _: 1
          }), _createVNode(_component_van_tab, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createVNode(TradeOptionHeader, {
              "list-show": false,
              "num-show": false,
              "trade-name": `ERS`,
              "kline-show": false
            })]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_component_van_button, {
              color: ieoType.value === 0 ? '#04AC92' : '#F7F6FB',
              block: "",
              onClick: _cache[3] || (_cache[3] = $event => ieoType.value = 0),
              style: _normalizeStyle({
                '--van-button-border-radius': '2px',
                color: ieoType.value === 0 ? 'white' : '#919497',
                width: '50%',
                clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)',
                fontWeight: 700,
                fontSize: '16px',
                '--van-button-default-height': '40px'
              })
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('buy')), 1)]),
              _: 1
            }, 8, ["color", "style"]), _createVNode(_component_van_button, {
              color: ieoType.value === 2 ? '#D04C64' : '#F7F6FB',
              block: "",
              onClick: _cache[4] || (_cache[4] = $event => ieoType.value = 2),
              style: _normalizeStyle({
                '--van-button-border-radius': '2px',
                color: ieoType.value === 2 ? 'white' : '#919497',
                width: '50%',
                clipPath: 'polygon(5% 0, 100% 0, 100% 100%, 0 100%)',
                fontWeight: 700,
                fontSize: '16px',
                '--van-button-default-height': '40px'
              })
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('sell')), 1)]),
              _: 1
            }, 8, ["color", "style"])]), ieoType.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createVNode(_component_van_button, {
              color: ieoCurrency.value === 'USDT' ? '#F08504' : '',
              onClick: _cache[5] || (_cache[5] = $event => ieoChange('USDT')),
              style: {
                "width": "24%",
                "height": "38px"
              }
            }, {
              default: _withCtx(() => [_hoisted_52]),
              _: 1
            }, 8, ["color"]), _createVNode(_component_van_button, {
              color: ieoCurrency.value === 'USDC' ? '#F08504' : '',
              onClick: _cache[6] || (_cache[6] = $event => ieoChange('USDC')),
              style: {
                "width": "24%",
                "height": "38px"
              }
            }, {
              default: _withCtx(() => [_hoisted_53]),
              _: 1
            }, 8, ["color"]), _createVNode(_component_van_button, {
              color: ieoCurrency.value === 'BTC' ? '#F08504' : '',
              onClick: _cache[7] || (_cache[7] = $event => ieoChange('BTC')),
              style: {
                "width": "24%",
                "height": "38px"
              }
            }, {
              default: _withCtx(() => [_hoisted_54]),
              _: 1
            }, 8, ["color"]), _createVNode(_component_van_button, {
              color: ieoCurrency.value === 'ETH' ? '#F08504' : '',
              onClick: _cache[8] || (_cache[8] = $event => ieoChange('ETH')),
              style: {
                "width": "24%",
                "height": "38px"
              }
            }, {
              default: _withCtx(() => [_hoisted_55]),
              _: 1
            }, 8, ["color"])])) : ieoType.value !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_unref(t)('optimal')), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
              class: "trade-num mt",
              style: _normalizeStyle({
                '--trade-num-focus': 'rgb(241, 198, 2)'
              })
            }, [_createVNode(_component_a_input_number, {
              value: form.number,
              "onUpdate:value": _cache[9] || (_cache[9] = $event => form.number = $event),
              bordered: false,
              style: {
                "width": "100%",
                "font-size": "14px"
              },
              onBlur: _cache[10] || (_cache[10] = $event => numInput.value = false),
              placeholder: _unref(t)('number'),
              type: "number",
              precision: 8,
              min: "0",
              onFocus: _cache[11] || (_cache[11] = $event => numInput.value = true)
            }, null, 8, ["value", "placeholder"]), _hoisted_57], 4), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", null, _toDisplayString(_unref(t)('useable')), 1), ieoType.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(assetList.value[ieoCurrency.value]) + " " + _toDisplayString(ieoCurrency.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(useService.value) + " ERS", 1))]), _createElementVNode("div", {
              class: "trade-num mt",
              style: _normalizeStyle({
                '--trade-num-focus': 'rgb(241, 198, 2)'
              })
            }, [_createVNode(_component_a_input_number, {
              value: form.total,
              "onUpdate:value": _cache[12] || (_cache[12] = $event => form.total = $event),
              bordered: false,
              style: {
                "width": "100%",
                "font-size": "14px"
              },
              placeholder: _unref(t)('tradeVol'),
              type: "number",
              precision: 8,
              min: "0",
              onBlur: _cache[13] || (_cache[13] = $event => totalInput.value = false),
              onFocus: _cache[14] || (_cache[14] = $event => totalInput.value = true)
            }, null, 8, ["value", "placeholder"]), ieoType.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(ieoCurrency.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_62, "USDT"))], 4), ieoType.value === 0 ? (_openBlock(), _createBlock(_component_van_button, {
              key: 2,
              class: "mt commit-btn",
              color: "#04AC92",
              block: "",
              onClick: commit
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('buy')), 1)]),
              _: 1
            })) : ieoType.value === 1 ? (_openBlock(), _createBlock(_component_van_button, {
              key: 3,
              class: "mt commit-btn",
              color: "#1890ff",
              block: "",
              onClick: commit,
              disabled: !pledgeEnable.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('lock')), 1)]),
              _: 1
            }, 8, ["disabled"])) : ieoType.value === 2 ? (_openBlock(), _createBlock(_component_van_button, {
              key: 4,
              class: "mt commit-btn",
              disabled: sellDisabled.value,
              color: "#D04C64",
              block: "",
              onClick: commit
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('sell')), 1)]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)])]), _createVNode(CustomTab, {
              style: {
                "margin-top": "12px"
              },
              "tab-list": [_unref(t)('subBuyHistory'), _unref(t)('sellHistory')],
              "offset-top": 96,
              "all-show": false,
              onChange: orderChange
            }, {
              tab1: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_unref(store).state.token === '' ? (_openBlock(), _createBlock(EmptyLogin, {
                key: 0
              })) : (_openBlock(), _createBlock(IEOOrderList, {
                key: 1,
                ref_key: "ieoOrder",
                ref: ieoOrder,
                kline: klineKey.value,
                "coin-id": _unref(store).state.marketInfo[klineKey.value]?.stockId
              }, null, 8, ["kline", "coin-id"]))])]),
              tab2: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_unref(store).state.token === '' ? (_openBlock(), _createBlock(EmptyLogin, {
                key: 0
              })) : (_openBlock(), _createBlock(IEOSellList, {
                key: 1,
                ref_key: "ieoSellOrder",
                ref: ieoSellOrder,
                "coin-id": _unref(store).state.marketInfo[klineKey.value]?.stockId
              }, null, 8, ["coin-id"]))])]),
              _: 1
            }, 8, ["tab-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["active"])]),
        _: 1
      }, 8, ["modelValue", "pulling-text", "loosing-text", "loading-text"])]);
    };
  }

};